import { IGetParamsGET_STOPPOINT_JSON_SHIPPING, IResponseGetBusStations, IStopPointShipping } from "@/api/busStaitions/types";
import { RootState } from "@/store/redux/store";
import { IBusStation } from "@/shared/types/busStaition";
import { useDispatch, useSelector } from "react-redux";
import { controlLoadingMap, setBoundsMap, setBusStaitionsOnMap, setBusStation, setBusStations, setBusStationsForm, setBusStationsFormTo, setBusStationsShippingFrom, setBusStationsShippingTo, setBusStationsTo, setBusStationTo, setCity, setViewPortMapMode } from "../store/mapScreenSlce";
import { useEffect } from "react";
import apiBusStations from "../../../api/busStaitions/apiBusStaitions";
import { getCityLocalStorage } from "../../../store/localStorage/city";
import useMap from "./useMap";
import useToastMap from "./useToast";
import { IRoadmapMappoint } from "@/shared/types/roadmap";
import { ICity } from "@/shared/types/city";
import { getStopsFrom } from "../../../services/GET_FROM_OR_TO/GET_FROM_OR_TO";

//TODO перенести в отдельый сервис 
function useBusstaitions() {
    const dispatch = useDispatch();
    const { city, cityTo, busStations, busStationsTo, roadmap, mapMode } = useSelector((state: RootState) => state.mapScreen);
    const { changeStateAndZoomMap } = useMap();
    const { openToastMap, hideToastMap } = useToastMap();

    async function fillBusStations(city: ICity, isTo: boolean = false, isOnMap = false) {
        try {
            if (!city) { return }
            openToastMap('loading', 'Загрузка остановочных пунктов')
            const busStations: IBusStation[] = await getBusStaitionsByCityIdAndAdapter(city);
            if (!isTo) {
                dispatch(setBusStations(busStations));
            } else {
                dispatch(setBusStationsTo(busStations));
            }
            if (isOnMap) {
                dispatch(setBusStaitionsOnMap(busStations));
            }

            return busStations;
        }
        catch (err) {
            throw new Error(err);
        }
        finally {
            hideToastMap();
        }
    }

    /** Получить остановки на карте между двумя городами */
    async function fillBusStationsTwoCity({
        cityFrom,
        cityToData,
        staitionsStoppointForm,
        staitionsStoppointTo,
    }: { cityFrom: ICity, cityToData: ICity, staitionsStoppointForm: IStopPointShipping[], staitionsStoppointTo: IStopPointShipping[] }) {
        try {
            if (!cityFrom) { return }

            let staitionsFrom = [];
            if (city && city.id.toString() === cityFrom.id.toString() && busStations.length > 0) {
                staitionsFrom = busStations;
            } else {
                staitionsFrom = await fillBusStations(city);
            }

            let staitionsTo = [];

            if (cityTo && cityTo.id.toString() === cityToData.id.toString() && busStationsTo.length > 0) {
                staitionsTo = busStationsTo;
            } else {
                staitionsTo = await fillBusStations(cityToData, true);
            }

            if (mapMode === 'busStops') {
                const staitions = [...staitionsFrom, ...staitionsTo];

                const stopPoints = [...staitionsStoppointForm, ...staitionsStoppointTo]

                const filterStaitions = staitions.filter((staition: IBusStation) =>
                    stopPoints.some((sp) => sp.stoppoint_id.toString() === staition.area_id.toString())
                );
                dispatch(setBusStaitionsOnMap(filterStaitions))
            }
        }
        catch (err) {
            throw new Error(err);
        }
        finally {

        }
    }

    async function getBusStaitionsByCityIdAndAdapter(city: ICity): Promise<IBusStation[]> {
        try {
            // const data = await fetchBusStaitionsOnCity(city);
            const data = await apiBusStations.get({ NCITY_ID: city.id.toString() });
            if (!data || !data.stops) {
                return [];
            }
            const busStations = adapterBusStaitions(data.stops);
            return busStations;
        } catch (err) {
            throw new Error('Ошибка при получении остановочных пунктов');
        }
    }

    async function fillBusStationsByRoadmap(pointsRoadmap: IRoadmapMappoint[], cityId?: string, isOnMap: boolean = true, transportType?: "ТРАМВАЙ" | "АВТОБУС") {

        if (cityId || city) {
            // @ts-ignore
            const busStations: IBusStation[] = pointsRoadmap
                .filter(point => point.is_stop === 1)
                .map(point => ({
                    id: point.stop_id ?? point.id,
                    name: point.stop_name || '',
                    stop_latitude: point.latitude,
                    stop_longitude: point.longitude,
                    city_id: cityId || city.id,
                    isRoad: true,
                    transport_type: point.transport_type ?? transportType ?? undefined,
                }));
            //dispatch(setBusStations(busStations));
            //dispatch(setBusStaitionsOnMap(busStations))
            if (isOnMap) { dispatch(setBusStaitionsOnMap(busStations)) }
        }
    }


    function initBusStations() {
        const city = getCityLocalStorage();
        if (city) {
            dispatch(setCity(city));
            changeStateAndZoomMap([city.center_x_coord, city.center_y_coord], 12);
        }
    }

    async function selectBusStaition(data: IBusStation, isViewPort: boolean = true) {
        console.log('selectBusStaition', data)
        dispatch(setBusStation(data));
        if (isViewPort && data && mapMode === 'busStops') {
            dispatch(setViewPortMapMode('centerChange'));
            changeStateAndZoomMap([Number(data.stop_latitude), Number(data.stop_longitude)], 15)
        }
    }

    async function selectBusStaitionTo(data: IBusStation) {
        dispatch(setBusStationTo(data));
    }

    async function fetchStaitionsShipping({
        cityId,
        cityToId,
        type = 'TO',
        date = new Date().toISOString().split('T')[0],
        busStationFromId,
    }: IFetchStationsShippingProps) {
        try {
            if (!cityId && !cityToId) return;
            if (type === 'TO') {
                dispatch(controlLoadingMap('fetchBusStationShippingTo'))
            } else {
                dispatch(controlLoadingMap('fetchBusStationShippingFrom'))
            }

            const resData: IGetParamsGET_STOPPOINT_JSON_SHIPPING = {
                NLOCALITY_ID: cityId ?? '', CTYPE: type
            }
            if (cityToId) {
                resData.NLOCALITY_ID_TO = cityToId
            }

            if (date) {
                resData.dDATE = date;
            }
            // if (busStationFromId) {
            //     resData.NSTOPPOINT_FROM_ID = busStationFromId.toString();
            // }
            const res = await apiBusStations.getShipping(resData);
            // if (type === 'TO') {
            //     dispatch(setBusStationsShippingTo(res.stoppoints));
            // } else {
            //     dispatch(setBusStationsShippingFrom(res.stoppoints));
            // }
            return res.stoppoints;
        }
        catch (err) {
            console.log(err)
            throw new Error(err);
        }
        finally {
            if (type === 'TO') {
                dispatch(controlLoadingMap('fetchBusStationShippingTo'))
            } else {
                dispatch(controlLoadingMap('fetchBusStationShippingFrom'))
            }
        }
    }

    return ({
        fillBusStations,
        fillBusStationsByRoadmap,
        fillBusStationsTwoCity,
        selectBusStaition,
        selectBusStaitionTo,
        fetchStaitionsShipping,
        getBusStaitionsByCityIdAndAdapter,
    })
}

export default useBusstaitions;



function adapterBusStaitions(busStaitions: Record<string, IBusStation>): IBusStation[] {
    const updated = Object.values(busStaitions)
        .map((busStation) => ({
            ...busStation,
            stop_latitude: busStation.stop_latitude.toString().replace(',', '.'),
            stop_longitude: busStation.stop_longitude.toString().replace(',', '.'),
        }))
    return updated;
}

interface IFetchStationsShippingProps {
    date?: string;
    cityId?: string;
    cityToId?: string;
    busStation?: IBusStation;
    busStationFromId?: string;
    city?: any; // уточни тип, если есть
    type?: 'TO' | 'FROM';
}